/**
 *@英语
 *@params
 *@author WangPing
 *@date 2020-07-20
 */

export default {
  _not_interested_in_this_video: 'Not interested in this video? %second%',
  _switch_one: 'Switch one',
  _next_reward_text: 'Watch another video to earn',
  _next_reward_button: 'Play now',
}